import { NgModule } from '@angular/core';
import { FormPortalConfigDirective } from './form-portal-config.directive';
import { FormPortalConfigFieldDirective } from './form-portal-config-field.directive';

@NgModule({
  declarations: [FormPortalConfigDirective, FormPortalConfigFieldDirective],
  imports: [],
  exports: [FormPortalConfigDirective, FormPortalConfigFieldDirective],
})
export class FormPortalConfigModule {}
